/**
 * Connected intra-oral scanner exposed in the dentist portal.
 * Lab-internal calibration / firmware fields are stripped at the
 * mapper layer.
 */
export const ScannerStatus = {
  Online: 'online',
  Offline: 'offline',
} as const;
export type ScannerStatus = (typeof ScannerStatus)[keyof typeof ScannerStatus];

export interface Scanner {
  readonly id: string;
  readonly name: string;
  readonly location: string;
  readonly status: ScannerStatus;
  /** Minutes since the device last checked in, only set when offline. */
  readonly offlineSinceMinutes: number | null;
}
